import { useEffect } from 'react';
import { capitalCase } from 'change-case';
import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Card, Stack, Link, /* Alert, */ Tooltip, Container, Typography, Button } from '@mui/material';
// routes
import { PATH_AUTH } from '../../routes/paths';
// hooks
import useAuth from '../../hooks/useAuth';
// layouts
// import AuthLayout from '../../layouts/AuthLayout';
// components
import Page from '../../components/Page';
import { MHidden } from '../../components/@material-extend';
import { LoginForm } from '../../components/authentication/login';
import AuthFirebaseSocials from '../../components/authentication/AuthFirebaseSocial';
import { analytics } from '../../contexts/FirebaseContext';
import { analyticsEvents } from '../../constants/analyticsEvents';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const { method, login } = useAuth();

  const handleLoginAuth0 = async () => {
    try {
      await login();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    analytics.setCurrentScreen('Login');
    analytics.logEvent(analyticsEvents.login_page_view);
  }, []);

  return (
    <RootStyle title="Dagpacket- Login">
      {/* <AuthLayout>
        No tienes cuenta? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to={PATH_AUTH.register}>
          Registrate
        </Link>
      </AuthLayout> */}

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            Hola, Bienvenido de nuevo!
          </Typography>
          <img src="/static/illustrations/illustration_login.png" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack direction="row" alignItems="center" sx={{ mb: 5 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Typography variant="h4" gutterBottom>
                Ingresa a DagPacket
              </Typography>
              <Typography sx={{ color: 'text.secondary' }}>Ingresa tus datos abajo.</Typography>
            </Box>

            <Tooltip title={capitalCase(method)}>
              <Box component="img" src={`/static/auth/ic_${method}.png`} sx={{ width: 32, height: 32 }} />
            </Tooltip>
          </Stack>

          {/* {method === 'firebase' && <AuthFirebaseSocials />} */}

          {/* <Alert severity="info" sx={{ mb: 3 }}>
            Use email : <strong>demo@minimals.cc</strong> / password :<strong>&nbsp;demo1234</strong>
          </Alert> */}

          {method !== 'auth0' ? (
            <LoginForm />
          ) : (
            <Button fullWidth size="large" type="submit" variant="contained" onClick={handleLoginAuth0}>
              Inicia sesión
            </Button>
          )}

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" align="center" sx={{ mt: 3 }}>
              No tienes cuenta?&nbsp;
            </Typography>
            <Button
              sx={{ mt: 1 }}
              variant="contained"
              color="warning"
              // color="inherit"
              // fullWidth
              component={RouterLink}
              to={PATH_AUTH.register}
              onClick={() => {
                analytics.logEvent(analyticsEvents.login_register_click);
              }}
            >
              Registrate
            </Button>
          </Box>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
